<template>
  <div
    v-if="shouldShow"
  >
    <small
      v-if="regionContentRating"
      :class="$style.textBlock"
    >{{ regionContentRating }}</small>
    <small
      v-else-if="contentRatingMessage"
      :class="$style.textBlock"
    >{{ $t('video.info.content_rating', { content_rating: contentRatingMessage }) }}</small>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Model } from '@viddsee/server-api-client';

export default Vue.extend({
  props: {
    video: {
      type: Object as PropType<Model.Video.Info>,
      required: true,
    },
  },
  computed: {
    regionContentRating(): string | null {
      if (this.video.regionContentRating == null) return null;

      return [
        this.video.regionContentRating.name,
        this.video.regionContentRating.reason,
      ].join(' | ');
    },

    contentRatingMessage(): string | null {
      return this.video.contentRatings.join(', ') || null;
    },

    shouldShow(): boolean {
      return !!(
        this.contentRatingMessage ||
        this.regionContentRating
      );
    },
  },
});
</script>

<style module>
.textBlock + .textBlock::before {
  content: "| ";
}
</style>
